export default "__VITE_ASSET__D9UlZ6J2__"